<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="conscent ? handleContinue() : (beforeWeBegin = true)"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.mdco_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.mdco_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						:loading="exportando"
						@click="downloadCSVMedicao()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="quantityPerPage"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #stepper>
				<div class="w-full flex justify-center mb-4">
					<RadialStepper
						v-model="step"
						:steps="[
							{ name: $t('cadastrarMedicao'), step: 1 },
							{ name: $t('mapProperties'), step: 2 },
							{ name: $t('visualizeDispersion'), step: 3 },
							{ name: $t('summary'), step: 4 },
						]"
					/>
					<!-- <BreadCrumb v-model="step"
          :crumbs="[{ name: 'Cadastrar Medição', step: 1 }, { name: 'Mapear Propriedades', step: 2, disabled: true }]">
        </BreadCrumb> -->
				</div>
			</template>
			<template #actions>
				<div class="py-4">
					<p class="!m-0">
						{{ $t('preenchaOsCampos') }}
					</p>
					<a
						@click="
							showForm = false
							beforeWeBegin = true
						"
						>{{ $t('verInstrucoes') }}</a
					>
				</div>
			</template>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 1rem">
					<InputText
						v-model="model.mdco_ds_descricao"
						:label="$t('description') + '*'"
						@input="onDescriptionChange"
					/>
					<div class="flex w-full items-center gap-2">
						<DropdownFk
							v-model="model.fk_esfl_estrato_florestal"
							class="w-full"
							:label="$t('forestStratification') + '*'"
							:dropdown-options="estratosComFazenda"
						/>
						<Spinner
							v-if="fetchingPlantios"
							class="mb-2 h-5"
						/>
					</div>

					<label class="uppercase font-semibold text-[#464947]">{{ $t('inventoryType') }}*</label>
					<RadioButton
						v-model="model.tipoInventario"
						:label="$t('inventarioQualidade')"
						name="tipo"
						model-value="ifq"
					/>
					<RadioButton
						v-model="model.tipoInventario"
						:label="$t('inventarioInstalacao')"
						name="tipo"
						model-value="ifi"
					/>
					<RadioButton
						v-model="model.tipoInventario"
						:label="$t('inventarioContinuo')"
						name="tipo"
						model-value="ifc"
					/>
					<RadioButton
						v-model="model.tipoInventario"
						:label="$t('inventarioPreCorteIPC')"
						name="tipo"
						model-value="ipc"
					/>

					<FileUpload
						v-if="!isEdit"
						class="margin: 1rem 0;"
						extensions-accepted=".csv"
						:disabled="!plantios.length"
						:label="$t('selectMeasurementFile')"
						@onUpload="handleFileUpload($event)"
					/>
					<p
						v-show="content.errors.length"
						style="
							background-color: var(--color-error-background);
							width: 100%;
							padding: 0.3rem;
							border-radius: 5px;
							color: white;
						"
					>
						{{ $t('badCsvImport') }}
					</p>
					<div class="container__crud__crudform__buttons">
						<Button
							v-if="!isPilha"
							:label="isEdit ? `${$t('view')} ${$t('measurement')}` : $t('validateBase')"
							color="trv-default"
							semantic-class="mini"
							:disabled="disabled"
							@click="
								enableFileUpload = true
								showForm = false
								step = 2
							"
						/>

						<Button
							v-if="isPilha"
							:label="$t('exportStackData')"
							color="trv-default"
							semantic-class="mini"
							@click="
								getRawDataPilhaExport()
								showForm = false
								step = 2
							"
						/>

						<Button
							v-if="descriptionChanged"
							:label="$t('save')"
							color="trv-default"
							@click="saveClick"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
		<Modal
			v-if="enableFileUpload && !isEdit"
			align="up"
			style="background-color: white; overflow-y: scroll"
		>
			<div style="width: 100vw">
				<div style="margin: 0 auto; width: 80vw">
					<div v-show="!showOutliers">
						<div class="w-full justify-center flex mb-4">
							<BreadCrumb
								v-model="step"
								:crumbs="[
									{ name: $t('cadastrarMedicao'), step: 1 },
									{ name: $t('mapProperties'), step: 2 },
									{ name: $t('visualizeDispersion'), step: 3 },
									{ name: $t('summary'), step: 4 },
								]"
							/>
						</div>

						<DataMapper
							v-if="step === 2"
							v-model="colunaAtributo"
							:step="step"
							:is-edit="isEdit"
							has-chart
							:filename="file?.name || ''"
							:data="medicoesNormalizadas"
							:colunas="colunasMapeamento"
							@next="step++"
							@previous="step--"
							@exportarOutliers="exportarOutliers"
							@cellChanged="handleCellChanged"
							@change="handleFileUpload($event)"
							@close="
								enableFileUpload = false
								showForm = true
							"
							@done="saveClick"
						>
							<template
								v-if="!isEdit"
								#cards
							>
								<div
									v-if="mapeamentosObrigatorios.length || dadoMapeadoDeTipoIncorreto.length"
									style="display: flex; gap: 1rem; padding: 0 0 0.6rem 0; justify-content: center"
								>
									<!-- Repetido no grupo v-else abaixo de proposito: a data de coleta faltando
									     precisa aparecer nos dois cenarios, e os cards so ficam lado a lado quando
									     estao no mesmo container (o max-width em % do InfoCard colapsa se aninhado
									     em outro flex). -->
									<InfoCard
										v-if="dataColetaAusente.length"
										:details="dataColetaAusente"
										:description="$t('dataDaColeta')"
										type="error"
									/>

									<InfoCard
										v-if="mapeamentosObrigatorios.length"
										:details="mapeamentosObrigatorios"
										:description="$t('mapeamentoObrigatorio')"
										type="error"
									/>

									<InfoCard
										v-if="dadoMapeadoDeTipoIncorreto.length"
										:details="dadoMapeadoDeTipoIncorreto"
										:description="$t('dadosMapeadosComTipoIncorreto')"
										type="error"
									/>
								</div>
								<div
									v-else
									style="display: flex; gap: 1rem; padding: 0 0 0.6rem 0; justify-content: center"
								>
									<InfoCard
										v-if="dominantesEmAtencao.length"
										:details="
											dominantesEmAtencao.map(
												(m) =>
													`${$t('plot')} ${m.parcela} ${$t('tem')} ${m.dominantes.length} ${$t('numeroIdealDominantes')} ${m.recomendado}`,
											)
										"
										:description="$t('dominantes')"
										type="warning"
									/>

									<InfoCard
										v-if="arvoresMedidasPorParcela.length"
										:details="
											arvoresMedidasPorParcela.map(
												(m) =>
													`${$t('plot')} ${m.parcela} ${$t('tem')} ${m.arvoresMedidas.length} ${$t('numeroIdealMedicoes')} ${Math.round(m.limiteInferior)} e ${Math.round(m.limiteSuperior)}`,
											)
										"
										:description="$t('measurements')"
										type="warning"
									/>

									<InfoCard
										v-if="dadoObrigatorio.length"
										:details="dadoObrigatorio"
										:description="$t('dadoObrigatorio')"
										type="error"
									/>

									<InfoCard
										v-if="numeroNegativo.length"
										:details="numeroNegativo"
										:description="$t('numeroNegativo')"
										type="error"
									/>

									<!-- Ausencia e datas fora de faixa dividem o mesmo card para nao repetir o titulo -->
									<InfoCard
										v-if="dataColetaAusente.length || dataColeta.length"
										:details="[...dataColetaAusente, ...dataColeta]"
										:description="$t('dataDaColeta')"
										type="error"
									/>

									<InfoCard
										v-if="dataPlantio.length"
										:details="detalhesPlantio"
										:description="$t('plantationDate')"
										type="error"
									/>

									<InfoCard
										v-if="nenhumPlantioEstaCadastrado"
										:details="[$t('plantioComOsCodigosCSVNaoEstaCadastrado')]"
										:description="$t('plantio')"
										type="error"
									/>
									<InfoCard
										v-else-if="plantiosNaoCadastrados.length"
										:details="
											plantiosNaoCadastrados.map(
												(plantio) =>
													`${$t('plantio')} ${plantio} ${$t('naoEncontradoNoEstrato')} ${estratos.find((e) => e.id === model.fk_esfl_estrato_florestal)['Código']}.  ${$t('plantioSeraExcluidoMedicao')}`,
											)
										"
										:description="$t('plantio')"
										type="warning"
									/>

									<InfoCard
										v-if="conteudoSemPlantio"
										:details="[$t('arquivoSemDadosDePlantioDetalhe')]"
										:description="$t('arquivoSemDadosDePlantio')"
										type="error"
									/>

									<InfoCard
										v-if="categoriasNaoCadastradas.length"
										:details="
											categoriasNaoCadastradas.map(
												(medicao) =>
													`${$t('categoria')} '${medicao[bindColunas.categoriaDaArvore]}' ${$t('naoCadastradaNoSistema')}`,
											)
										"
										:description="$t('treeCategory')"
										type="error"
									/>

									<InfoCard
										v-if="categoriasFitoNaoCadastradas.length"
										:details="
											categoriasFitoNaoCadastradas.map(
												(medicao) =>
													`${$t('categoria')} '${medicao[bindColunas.categoriaFitossanidade]}' ${$t('naoCadastradaNoSistema')}`,
											)
										"
										:description="$t('fitoCategory')"
										type="error"
									/>

									<InfoCard
										v-if="tipoMatoDominanteLinhaSemPadrao.length"
										:details="
											tipoMatoDominanteLinhaSemPadrao.map(
												(medicao) =>
													`${$t('dominantBushType')} (${$t('linha')}) '${medicao[bindColunas.tipoMatoDominante]}' ${$t('naoPodeSerDiferenteDe')} (Sem mato, Germinação indefinida, Folha larga, Cipó, Gramínea)`,
											)
										"
										:description="`${$t('dominantBushType')} (${$t('linha')})`"
										type="error"
									/>

									<InfoCard
										v-if="tipoMatoDominanteEntrelinhaSemPadrao.length"
										:details="
											tipoMatoDominanteEntrelinhaSemPadrao.map(
												(medicao) =>
													`${$t('dominantBushType')} (${$t('entrelinha')}) '${medicao[bindColunas.matoDominanteEntrelinha]}' ${$t('naoPodeSerDiferenteDe')} (Sem mato, Germinação indefinida, Folha larga, Cipó, Gramínea)`,
											)
										"
										:description="`${$t('dominantBushType')} (${$t('entrelinha')})`"
										type="error"
									/>

									<InfoCard
										v-if="tipoMatoAssociadoLinhaSemPadrao.length"
										:details="
											tipoMatoAssociadoLinhaSemPadrao.map(
												(medicao) =>
													`${$t('associatedBushType')} (${$t('linha')}) '${medicao[bindColunas.tipoMatoAssociado]}' ${$t('naoPodeSerDiferenteDe')} (Sem mato, Germinação indefinida, Folha larga, Cipó, Gramínea)`,
											)
										"
										:description="`${$t('associatedBushType')}  (${$t('linha')})`"
										type="error"
									/>

									<InfoCard
										v-if="tipoMatoAssociadoEntrelinhaSemPadrao.length"
										:details="
											tipoMatoAssociadoEntrelinhaSemPadrao.map(
												(medicao) =>
													`${$t('associatedBushType')} (${$t('entrelinha')}) '${medicao[bindColunas.matoAssociadoEntrelinha]}' ${$t('naoPodeSerDiferenteDe')} (Sem mato, Germinação indefinida, Folha larga, Cipó, Gramínea)`,
											)
										"
										:description="`${$t('associatedBushType')} (${$t('entrelinha')})`"
										type="error"
									/>

									<InfoCard
										v-if="categoriasInconsistentes.length"
										:details="
											categoriasInconsistentes.map(
												([chave, valores]) =>
													`${$t('fustesDaArvore')} ${chave}${$t('saoDiferentes')}: ${valores.map((valor) => valor[bindColunas.categoriaDaArvore])}`,
											)
										"
										:description="$t('treeCategory')"
										type="warning"
									/>

									<InfoCard
										v-if="semAlturaArvore.length"
										:details="
											[
												...new Set(
													semAlturaArvore.map((medicao) => medicao[bindColunas.categoriaDaArvore]),
												),
											].map((cat) => `Existem árvores com categoria ${cat} e sem altura`)
										"
										description="Árvores sem altura"
										type="error"
									/>

									<InfoCard
										v-if="semCoordenada.length"
										description="Parcelas sem coordenadas não estarão disponíveis para futuros inventários"
										type="warning"
									/>
								</div>
							</template>
						</DataMapper>
						<Button
							v-if="step === 2"
							class="float-right mt-4"
							width-auto
							:disabled="prevent"
							icon="fas fa-arrow-right"
							color="trv-default"
							:label="$t('continue')"
							@click="step++"
						/>
						<div v-if="step === 3">
							<div style="display: flex; gap: 1rem">
								<i
									style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
									class="fas fa-arrow-left"
									@click="step = 2"
								/>
								<h1 class="text-H5">
									{{ $t('visualizeDispersion') }}
								</h1>
							</div>
							<p>{{ $t('cliqueEmUmPontoParaEditar') }}</p>

							<div class="flex justify-end items-center gap-4">
								<Button
									width-auto
									:disabled="prevent"
									icon="fas fa-arrow-right"
									color="trv-default"
									:label="$t('continue')"
									@click="step++"
								/>
							</div>

							<OutliersChart
								:categorias-arvore="categorias"
								:bind-colunas="bindColunas"
								:series="dadosParaOutliersChart"
								:opcoes-eixo-x="opcoesEixoX"
								:opcoes-eixo-y="opcoesEixoY"
								@desconsiderar="desconsiderar"
								@changePoint="changePoint"
							/>
						</div>
						<div v-if="step === 4">
							<div style="display: flex; gap: 1rem">
								<i
									style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
									class="fas fa-arrow-left"
									@click="step = 3"
								/>
								<h1 style="margin: 0">
									{{ $t('summary') }}
								</h1>
							</div>
							<p>{{ `${$t('these')} ${medicoesNormalizadas.length} ${$t('referTo')}` }}:</p>
							<div style="display: flex; justify-content: space-evenly; padding: 2rem 0">
								<KPI
									:description="$t('sections')"
									:value="totalTalhoes"
								/>
								<KPI
									:description="$t('plantations')"
									:value="totalPlantios"
								/>
								<KPI
									:description="$t('plots')"
									:value="totalParcelas"
								/>
								<KPI
									:description="$t('trees')"
									:value="totalArvores"
								/>
								<KPI
									:description="$t('stems')"
									:value="totalFustes"
								/>
								<KPI
									:description="`${$t('predominantCategory')}`"
									:value="categoriaPredominante"
								/>
							</div>
							<Button
								style="float: right"
								:loading="salvando"
								:disabled="prevent"
								width-auto
								lefticon="fas fa-check"
								color="trv-default"
								:label="`${$t('import')} ${$t('measurement')}`"
								@click="saveClick"
							/>
						</div>
					</div>
					<div style="padding: 1rem 0" />
				</div>
			</div>
		</Modal>
		<Modal
			v-if="enableFileUpload && isEdit"
			style="background-color: white"
		>
			<div style="display: flex; align-items: center">
				<div>
					<div style="display: flex; gap: 1rem">
						<i
							style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
							class="fas fa-arrow-left"
							@click="
								enableFileUpload = false
								showForm = true
								atualizarSeries(model)
							"
						/>
						<h1 class="text-H5">
							{{ $t('visualizeDispersaoMedicao') }}
						</h1>
					</div>

					<p>Se preferir, clique em um ponto para fazer a edição</p>
					<OutliersChart
						:categorias-arvore="categorias"
						:bind-colunas="bindColunas"
						:series="dadosParaOutliersChart"
						:opcoes-eixo-x="opcoesEixoX"
						:opcoes-eixo-y="opcoesEixoY"
						viewing
						@desconsiderar="desconsiderar"
						@changePoint="changePoint"
					/>

					<div class="flex justify-between">
						<UIButton
							text="voltar"
							secondary
							@click="
								enableFileUpload = false
								showForm = true
								atualizarSeries(model)
							"
						/>
						<UIButton
							text="salvar alterações"
							:disabled="!ableToSave"
							:loading="salvandoAlteracoes"
							@click="salvarAlteracoes"
						/>
					</div>
				</div>
			</div>
		</Modal>
		<InstrucaoMedicaoInventario
			v-if="beforeWeBegin"
			chave="medicao"
			:colunas-cadastrais="colunasCadastrais"
			:colunas-coleta="colunasColeta"
			:colunas-mato-competicao="colunasMatoCompeticao"
			@continue="handleContinue"
			@previous="handlePrevious"
		/>
	</div>
</template>

<script>
import { useLocalStorage } from '@vueuse/core'
import download from 'downloadjs'

import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import UIButton from '../../../../components/ui/button/Button'
// import Dropdown from "../../../../components/Dropdown/Dropdown";
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb.vue'
import DataMapper from '../../../../components/DataMapper/DataMapper'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import FileUpload from '../../../../components/FileUpload/FileUpload'
import GridPagination from '../../../../components/GridPagination/GridPagination.vue'
import InfoCard from '../../../../components/InfoCard/InfoCard'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import InstrucaoMedicaoInventario from '../../../../components/InstrucaoMedicao/InstrucaoMedicaoInventario'
import KPI from '../../../../components/KPI/KPI'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Modal from '../../../../components/Modal/Modal'
import OutliersChart from '../../../../components/OutliersChart/OutliersChart'
import RadialStepper from '../../../../components/RadialStepper/RadialStepper'
import RadioButton from '../../../../components/RadioButton/RadioButton'

import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'
import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import MedicaoesInventarioMixins from '../../../../mixins/MedicaoesInventarioMixins'
import OutliersMedicaoMixins from '../../../../mixins/OutliersMedicaoMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'
import { exportarCsv } from '../../../../utils/csvHellpers'
import { parseDate } from '../../../../utils/helpers'

import {
	createMedicao,
	deleteMedicaoByIdList,
	getAllMedicoesInventarioPagination,
	getDadosValidacaoConsistencia,
	importMedicaoInventarioCSV,
	updateMedicao,
} from '../../../../services/requests/MedicoesInventarioRequests'

import Spinner from '../../../../components/Spinner/Spinner'

import { recuperaDispersao } from '../../../../services/requests/ArvoreRequests'

import { getPlantiosByEstratoFlorestalId } from '../../../../services/requests/PlantioRequests'

import { getDropdownEstratosFlorestaisComFkFazenda } from '../../../../services/requests/EstratoFlorestalRequests'
import { getRawDataPilha } from '../../../../services/requests/ExportacaoRequests'
import { getTipoDeServicoCSVDropdown } from '../../../../services/requests/TipoDeServicoRequests'

import { outliersMessage } from '../../../../utils/enums/OutliersMessage'

export default {
	name: 'MedicaoInventario',
	components: {
		KPI,
		Button,
		CrudForm,
		CrudTable,
		InfoCard,
		InstrucaoMedicaoInventario,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		GridPagination,
		DropdownFk,
		OutliersChart,
		UIButton,
		KebabMenu,
		Modal,
		DataMapper,
		FileUpload,
		BreadCrumb,
		RadialStepper,
		Spinner,
		RadioButton,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [
		ControllingPaginationMixins,
		RegistersMixins,
		MedicaoesInventarioMixins,
		OutliersMedicaoMixins,
	],
	data() {
		return {
			fetchingPlantios: false,
			step: 1,
			beforeWeBegin: false,
			salvando: false,
			exportando: false,
			totalRecords: 0,
			descriptionChanged: false,
			showExclusionAlert: false,
			initialDescription: '',
			textFilter: '',
			novaMedicao: {
				talhao: '',
				plantio: '',
				parcela: '',
				areaParcela: '',
				dataPlantio: '',
				dataColeta: '',
				linha: '',
				arvore: '',
				fuste: '',
				dap: '',
				cap: '',
				categoriaDaArvore: '',
				categoria2: '',
				inclinacao: '',
				ht: '',
				coordenadaX: '',
				coordenadaY: '',
			},
			enableFileUpload: false,
			showOutliers: false,
			intention: {},
			headersSelecionados: ['tipoDeServico', 'fazenda', 'mdco_ds_descricao', 'mdco_cd_codigo'],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				mdco_cd_codigo: '',
				mdco_ds_descricao: '',
				fk_tpsv_tipo_servico: '',
				fk_esfl_estrato_florestal: '',
				fk_fzda_fazenda: '',
				fk_orsv_ordem_servico: '',
				tipoInventario: 'ifq',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				prefix: 'ME-',
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'mdco_ds_descricao',
				titleCardPropertie: 'mdco_cd_codigo',
			},

			tableHeaders: [
				{ key: 'mdco_cd_codigo', value: this.$t('code'), isActive: true },
				{
					key: 'mdco_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{ key: 'fazenda', value: this.$t('farm'), isActive: true },
				{
					key: 'estratoFlorestal',
					value: this.$t('forestStratification'),
					isActive: false,
				},
				{
					key: 'tipoDeServico',
					value: this.$t('inventoryType'),
					isActive: true,
				},
				{
					key: 'ordemDeServico',
					value: this.$t('serviceOrder'),
					isActive: false,
				},
				{
					key: 'mdco_dt_referencia',
					value: this.$t('referenceDate'),
					isActive: false,
				},
				{
					key: 'mdco_md_precipitacao',
					value: this.$t('precipitation'),
					isActive: false,
				},
				{
					key: 'mdco_md_temperatura',
					value: this.$t('temperature'),
					isActive: false,
				},
				{
					key: 'mdco_md_umidade',
					value: this.$t('humidity'),
					isActive: false,
				},
			],
			/**
			 * fazendas que serão dispostas no dropdown para atrelar a fazenda
			 */
			estratos: [],

			/**
			 * Tipos de Servicos vindo do banco de dados
			 */
			tiposDeServico: [],
		}
	},

	computed: {
		estratosComFazenda() {
			return this.estratos.filter((f) => f.fk_fzda_fazenda)
		},
		disabled() {
			return (
				this.disableSaveButton ||
				!this.camposObrigatoriosPreenchidos ||
				this.content.errors.length !== 0
			)
		},
		prevent() {
			return (
				// Enquanto o mapeamento estiver incompleto ou com tipo errado, podeIniciarValidacaoEstrutural
				// e falso e todas as validacoes abaixo retornam vazio — avancar aqui seria avancar sem validacao.
				this.mapeamentosObrigatorios.length > 0 ||
				this.dadoMapeadoDeTipoIncorreto.length > 0 ||
				this.dataColetaAusente.length > 0 ||
				this.semAlturaArvore.length > 0 ||
				this.categoriasNaoCadastradas.length > 0 ||
				this.dataPlantio.length > 0 ||
				this.dataColeta.length > 0 ||
				this.numeroNegativo.length > 0 ||
				this.dadoObrigatorio.length > 0
			)
		},
		conscent() {
			return JSON.parse(useLocalStorage('conscent-medicao', false).value)
		},
		isEmpty() {
			return Object.values(this.novaMedicao).every((value) => value != '')
		},
		/**
		 * Verdadeiro quando o CSV importado tem linhas, mas nenhuma possui o
		 * código do plantio preenchido (todas foram filtradas por Plantio vazio).
		 */
		conteudoSemPlantio() {
			return this.content?.data?.length > 0 && this.medicoesNormalizadas.length === 0
		},
		tipoDeMato() {
			return {
				'Sem mato': 'SEMMATO',
				'Germinação indefinida': 'GERMINACAOINDEFINIDA',
				'Folha larga': 'FOLHALARGA',
				Cipó: 'CIPO',
				Gramínea: 'GRAMINEA',
			}
		},

		detalhesPlantio() {
			return this.dataPlantio.map((medicao) => {
				const codigo = medicao[this.bindColunas.plantio]
				const plantioObj = this.plantios.find(
					(plantio) =>
						plantio.plaes_tbg_ptio_plantio &&
						plantio.plaes_tbg_ptio_plantio.ptio_cd_codigo === codigo,
				)

				let dataFormatada = ''
				if (
					plantioObj &&
					plantioObj.plaes_tbg_ptio_plantio &&
					plantioObj.plaes_tbg_ptio_plantio.ptio_dt_plantio
				) {
					const data = new Date(plantioObj.plaes_tbg_ptio_plantio.ptio_dt_plantio)
					dataFormatada = isNaN(data.getTime())
						? this.$t('dataInvalida')
						: data.toLocaleDateString()
				} else {
					dataFormatada = this.$t('dataNaoDisponivel')
				}

				return `${this.$t('plantationDate')} ${codigo} ${this.$t('naoPodeSerDiferenteDe')} : ${dataFormatada}`
			})
		},

		medicoesPreparadas() {
			return Object.keys(this.medicoesAgrupadasPorPlantio).map((plantio) => {
				// return this.medicoesAgrupadasPorPlantio[plantio].map(medicao => {
				const porParcela = this.medicoesAgrupadasPorPlantioEParcela.find(
					(p) =>
						p.plantio === this.medicoesAgrupadasPorPlantio[plantio][0][this.bindColunas.plantio],
				).medicoes
				return {
					idPlantio: this.plantios.find(
						(pt) =>
							pt.plaes_tbg_ptio_plantio.ptio_cd_codigo ===
							this.medicoesAgrupadasPorPlantio[plantio][0][this.bindColunas.plantio],
					).plaes_tbg_ptio_plantio.id,
					codigo: this.medicoesAgrupadasPorPlantio[plantio][0][this.bindColunas.plantio],
					codigoTalhao: this.medicoesAgrupadasPorPlantio[plantio][0][this.bindColunas.talhao],
					parcelas: Object.keys(porParcela).map((parcela) => {
						return {
							codigo: porParcela[parcela][0][this.bindColunas.parcela],
							formato: 'Circular',
							area: porParcela[parcela][0][this.bindColunas.areaParc],
							coordenadaX:
								porParcela[parcela][0][this.bindColunas.coordenadaX]
									?.toString()
									.replace(',', '.') || '',
							coordenadaY:
								porParcela[parcela][0][this.bindColunas.coordenadaY]
									?.toString()
									.replace(',', '.') || '',
							inclinacao: porParcela[parcela][0][this.bindColunas.inclinacao],
							dataDeColeta: parseDate(porParcela[parcela][0][this.bindColunas.dataColeta]),
							descricao: 'Criada pela importação de CSV',
							arvores: porParcela[parcela]
								.filter((arvore) => !this.medicoesDesconsideradas.includes(arvore.id))
								.map((arvore) => {
									let dap = null
									let cap = null

									if (this.bindColunas.cap === 'Nenhum' && arvore[this.bindColunas.dap]) {
										dap = Number(arvore[this.bindColunas.dap]?.toString().replace(',', '.'))
										cap = Number((dap * Math.PI).toFixed(2))
									} else if (this.bindColunas.dap === 'Nenhum' && arvore[this.bindColunas.cap]) {
										cap = Number(arvore[this.bindColunas.cap]?.toString().replace(',', '.'))
										dap = Number((cap / Math.PI).toFixed(2))
									} else {
										cap = arvore[this.bindColunas.cap]
											? Number(arvore[this.bindColunas.cap]?.toString().replace(',', '.'))
											: undefined
										dap = arvore[this.bindColunas.dap]
											? Number(arvore[this.bindColunas.dap]?.toString().replace(',', '.'))
											: undefined
									}

									return {
										linha: arvore[this.bindColunas.linha],
										arvore: arvore[this.bindColunas.arvore],
										fuste: arvore[this.bindColunas.fuste],
										cap: cap,
										dap: dap,
										diametroCopa: arvore[this.bindColunas.diametroCopa]
											? Number(arvore[this.bindColunas.diametroCopa]?.toString().replace(',', '.'))
											: undefined,
										ht: arvore[this.bindColunas.ht]
											? Number(arvore[this.bindColunas.ht]?.toString().replace(',', '.'))
											: undefined,
										categoriaDeArvore: arvore[this.bindColunas.categoriaDaArvore],
										categoriaDeFitossanidadeId: this.categoriasFito.find(
											(f) => f.nome === arvore[this.bindColunas.categoriaFitossanidade],
										)?.id,
										intensidadeFitossanidade:
											arvore[this.bindColunas.intensidadeFitossanidade] || undefined,
										matoCompeticao: {
											linhaMatoDominante:
												this.tipoDeMato[arvore[this.bindColunas.tipoMatoDominante]] || undefined,
											linhaMatoAssociado:
												this.tipoDeMato[arvore[this.bindColunas.tipoMatoAssociado]] || undefined,
											linhaAreaCoberta: arvore[this.bindColunas.coberturaMatoLinha] || undefined,
											linhaAlturaMato: arvore[this.bindColunas.alturaMatoLinha] || undefined,
											entrelinhaMatoDominante:
												this.tipoDeMato[arvore[this.bindColunas.matoDominanteEntrelinha]] ||
												undefined,
											entrelinhaMatoAssociado:
												this.tipoDeMato[arvore[this.bindColunas.matoDominanteAssociado]] ||
												undefined,
											entrelinhaMatoCoberto:
												arvore[this.bindColunas.coberturaMatoEntrelinha] || undefined,
											entrelinhaAlturaMato:
												arvore[this.bindColunas.alturaMatoEntrelinha] || undefined,
										},
										observacao:
											this.bindColunas.observacao !== 'Nenhum'
												? arvore[this.bindColunas.observacao]
												: undefined,
									}
								}),
						}
					}),
				}
				// })
			})
		},
		totalTalhoes() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.talhao)).length
		},
		totalPlantios() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.plantio)).length
		},
		totalParcelas() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.parcela)).length
		},
		totalArvores() {
			return Object.keys(this.medicoesAgrupadasPorArvore).length
		},
		totalFustes() {
			return Object.keys(this.medicoesAgrupadasPorFuste).length
		},
		categoriaPredominante() {
			return Object.keys(this.medicoesAgrupadasPorCategoria)
				.map((categoria) => {
					return {
						categoria,
						medicoes: this.medicoesAgrupadasPorCategoria[categoria],
					}
				})
				.sort((a, b) => (a.medicoes.length > b.medicoes.length ? -1 : 1))[0].categoria
		},

		isPilha() {
			if (this.model.tipoDeServico == 'Medição de Pilha') {
				return true
			} else {
				return false
			}
		},
		tipoServicoId() {
			const relation = {
				ifi: '001',
				ifc: '002',
				ipc: '003',
				ifq: '019',
			}

			return this.tiposDeServico.find((f) =>
				f.label.startsWith(relation[this.model.tipoInventario]),
			)?.value
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			const obrigatorios =
				this.model.fk_esfl_estrato_florestal != '' &&
				this.model.mdco_ds_descricao != '' &&
				this.model.tipoInventario != ''

			if (this.isEdit) {
				return obrigatorios && this.arvores.length > 0
			} else {
				return obrigatorios && this.file != undefined
			}
		},
	},
	watch: {
		step(value) {
			if (value === 1) {
				this.enableFileUpload = false
				this.showForm = true
			}
		},
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},

		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},
		/**
		 * A cada mudança do campo de estrato florestal, seta o fk_fzda_fazenda automaticamente
		 */
		model: {
			async handler(value) {
				if (value.fk_esfl_estrato_florestal) {
					this.fetchingPlantios = true
					const result = this.estratos.find(
						(estrato) => estrato.id === value.fk_esfl_estrato_florestal,
					)
					this.model.fk_fzda_fazenda = result ? result.fk_fzda_fazenda : ''

					const plantios = await getPlantiosByEstratoFlorestalId(value.fk_esfl_estrato_florestal)
					this.plantios = plantios.data.result
					this.fetchingPlantios = false
				}

				// if(this.camposObrigatoriosPreenchidos) {
				//   this.saveClick()
				// }
			},
			deep: true,
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['mdco_cd_codigo']
		getAllMedicoesInventarioPagination().then((response) => {
			// resultado vazio é legítimo (tenant sem medições) — o totalRegistros viaja em cada linha
			const medicoes = response.data.result || []
			this.totalRecords = medicoes.length > 0 ? medicoes[0].totalRegistros : 0
			medicoes.forEach((medicao) => this.formataMedicaoParaCrud(medicao))
			this.modelList = medicoes
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownEstratosFlorestaisComFkFazenda().then((response) => {
			this.estratos = response
		})

		getTipoDeServicoCSVDropdown().then((response) => {
			this.tiposDeServico = response
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.initialDescription !== value
			}
		},
		getRawDataPilhaExport() {
			getRawDataPilha(this.model.id).then((response) => {
				if (response.status == 200 && response.data.message) {
					window.open(response.data.message)
				} else if (response.status != 200) {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('exportStackDataError'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				} else if (response.status == 200 && !response.data.message) {
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: this.$t('exportStackDataEmpty'),
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			})
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllMedicoesInventarioPagination(pageNumber, pageSize, filteringWord).then((response) => {
				// resultado vazio limpa a grid (antes o return silencioso deixava as linhas antigas na tela)
				const medicoes = response.data.result || []
				this.totalRecords = medicoes.length > 0 ? medicoes[0].totalRegistros : 0
				medicoes.forEach((medicao) => this.formataMedicaoParaCrud(medicao))
				this.modelList = medicoes
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so a pagina ja
		 * carregada): busca tudo numa chamada antes de gerar o arquivo,
		 * sem mexer no estado da grid.
		 */
		async downloadCSVMedicao() {
			if (this.exportando) return
			this.exportando = true
			try {
				const response = await getAllMedicoesInventarioPagination(
					0,
					Math.max(this.totalRecords, 100),
					this.textFilter,
				)
				const items = response.data.result || []

				const cabecalhoDoCsvMedicao = [
					'Código',
					'Descrição',
					'Fazenda',
					'Estrato Florestal',
					'Tipo de Inventário',
					'Ordem de Serviço',
					'Data de Referência',
					'Precipitação',
					'Temperatura',
					'Umidade',
				]

				const linhas = items.map((item) => [
					item.mdco_cd_codigo,
					item.mdco_ds_descricao,
					item.fazenda,
					item.estratoFlorestal,
					item.tipoDeServico,
					item.ordemDeServico,
					item.mdco_dt_referencia,
					item.mdco_md_precipitacao,
					item.mdco_md_temperatura,
					item.mdco_md_umidade,
				])

				exportarCsv('export_medicao', cabecalhoDoCsvMedicao, linhas)
			} finally {
				this.exportando = false
			}
		},

		async atualizarSeries(model) {
			const arvores = await recuperaDispersao(model.id)
			this.arvores = arvores.data.result
		},
		handleContinue() {
			this.showNewModelForm()
			this.beforeWeBegin = false
		},
		handlePrevious() {
			this.beforeWeBegin = false
		},
		handleCellChanged(value) {
			this.content.data = this.content.data.map((medicao) => {
				if (medicao.id === value.id) {
					// Atualize o objeto desejado aqui
					return { ...medicao, [value.key]: value.value }
				}
				return medicao
			})
			// const registro = this.medicoesNormalizadas.find(e => e.id === value.id);
			// const index = this.medicoesNormalizadas.indexOf(registro);
			// this.medicoesNormalizadas.splice(index, 1, Object.assign(this.medicoesNormalizadas[0], { [value.key]: value.value }))
		},
		setDescricao(e) {
			this.model.mdco_ds_descricao = e
		},
		setColunaAtributo(e) {
			this.colunaAtributo = e
		},
		handleInput(e) {
			this.headersSelecionados = e.map((m) => m.key)
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createMedicaoToPost() {
			return {
				medicao: {
					id: uuidv4(),
					mdco_ds_descricao: this.model.mdco_ds_descricao,
					mdco_dt_referencia: new Date(),
					fk_fzda_fazenda: this.model.fk_fzda_fazenda,
					fk_orsv_ordem_servico: this.model.fk_orsv_ordem_servico,
				},
				idEstratoFlorestal: this.model.fk_esfl_estrato_florestal,
				idTipoDeServico: this.tipoServicoId,
				mdco_md_medida_parcela: this.medicoesPreparadas[0].parcelas[0].area,
			}
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * atualizado no banco de dados
		 */
		createMedicaoToPut() {
			return {
				medicao: {
					id: this.model.id,
					mdco_cd_codigo: this.model.mdco_cd_codigo,
					mdco_ds_descricao: this.model.mdco_ds_descricao,
					fk_fzda_fazenda: this.model.fk_fzda_fazenda,
					fk_orsv_ordem_servico: this.model.fk_orsv_ordem_servico,
				},
				idEstratoFlorestal: this.model.fk_esfl_estrato_florestal,
				idTipoDeServico: this.model.fk_tpsv_tipo_servico,
				mdco_md_medida_parcela: '',
			}
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * deletado no banco de dados
		 *  (Deve ser deletado medicoes e ordem de servico por enquanto)
		 */
		createMedicaoToDelete() {
			let idsMedicao = []
			let idsOrdemDeServico = []

			this.modelList
				.filter((medicao) => this.modelsIdWithCheckedToDelete.includes(medicao.id))
				.forEach((medicao) => {
					idsMedicao.push(medicao.id)
					idsOrdemDeServico.push(medicao.fk_orsv_ordem_servico)
				})

			return { idsMedicao, idsOrdemDeServico }
		},

		/**
		 * Formata campos do estrato florestal para exibir na tabela de crud
		 */
		formataMedicaoParaCrud(medicao) {
			medicao.isCheckedToDelete = false
		},

		exportarOutliers() {
			const validaLimitesHTxIdade = this.validaLimitesHTxIdade

			const medicoesParaExportar = this.medicoesNormalizadas.map((medicaoOriginal) => {
				// Criando uma cópia para evitar mutação direta
				const medicao = { ...medicaoOriginal }

				let dap = medicao[this.bindColunas.dap]
				let cap = medicao[this.bindColunas.cap]

				if (this.bindColunas.cap === 'Nenhum') {
					cap = (Number(medicao[this.bindColunas.dap]) * Math.PI).toFixed(2)
				} else if (this.bindColunas.dap === 'Nenhum') {
					dap = (Number(medicao[this.bindColunas.cap]) / Math.PI).toFixed(2)
				}

				medicao.dap = typeof dap === 'string' ? Number(dap.replace(',', '.')) : dap
				medicao.cap = typeof cap === 'string' ? Number(cap.replace(',', '.')) : cap
				medicao.ht = medicao[this.bindColunas.ht]
				medicao.dataPlantio = medicao[this.bindColunas.dataPlantio]
				medicao.dataColeta = medicao[this.bindColunas.dataColeta]
				medicao.categoriaDaArvore = medicao[this.bindColunas.categoriaDaArvore]

				if (medicao[this.bindColunas.ht]) {
					validaLimitesHTxIdade(medicao)
					this.validaLimitesDAPHTxIdade(medicao)
				}
				this.validaContextoLimitesContexto(medicao)
				this.setRiscoMedicao(medicao)

				return [
					medicao.talhao || medicao[this.bindColunas.talhao],
					medicao.plantio || medicao[this.bindColunas.plantio],
					medicao.parcela || medicao[this.bindColunas.parcela],
					medicao.areaParcela || medicao[this.bindColunas.areaParc],
					this.converterParaPadraoDeDataCorreto(medicao.dataPlantio) ||
						this.converterParaPadraoDeDataCorreto(medicao[this.bindColunas.dataPlantio]),
					this.converterParaPadraoDeDataCorreto(medicao.dataColeta) ||
						this.converterParaPadraoDeDataCorreto(medicao[this.bindColunas.dataColeta]),
					medicao.linha || medicao[this.bindColunas.linha],
					medicao.arvore || medicao[this.bindColunas.arvore],
					medicao.fuste || medicao[this.bindColunas.fuste],
					(medicao.cap || medicao[this.bindColunas.cap])?.toFixed(2).replace('.', ','),
					(medicao.dap || medicao[this.bindColunas.dap])?.toFixed(2).replace('.', ','),
					(medicao.ht || medicao[this.bindColunas.ht])?.toFixed(2).replace('.', ','),
					medicao.categoriaDaArvore || medicao[this.bindColunas.categoriaDaArvore],
					medicao.inclinacao || medicao[this.bindColunas.inclinacao],
					(medicao.coordenadaX || medicao[this.bindColunas.coordenadaX])?.replace('.', ','),
					(medicao.coordenadaY || medicao[this.bindColunas.coordenadaY])?.replace('.', ','),
					medicao.observacao || medicao[this.bindColunas.observacao],
					medicao.nivelRisco,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_PLANTIO) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_PLANTIO) ||
							insight.message.includes(outliersMessage.HT_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.HT_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ABAIXO_PLANTIO_IDADE) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_PLANTIO_IDADE),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.DAP_ACIMA_ESTRATO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.HT_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.HT_ACIMA_ESTRATO),
					)?.message,
					medicao.insights.find(
						(insight) =>
							insight.message.includes(outliersMessage.DAP_HT_ABAIXO_ESTRATO) ||
							insight.message.includes(outliersMessage.DAP_HT_ACIMA_ESTRATO),
					)?.message,
				]
			})

			const colunas = [
				'talhao',
				'plantio',
				'parcela',
				'area_da_parcela (m²)',
				'data_do_plantio',
				'data_de_coleta',
				'linha',
				'arvore',
				'fuste',
				'cap (cm)',
				'dap (cm)',
				'ht (m)',
				'categoria_da_arvore',
				'inclinacao',
				'coordenada_x',
				'coordenada_y',
				'observacao',
				'nivel_de_risco',
				'outlier_1',
				'outlier_2',
				'outlier_3',
				'outlier_4',
				'outlier_5',
				'outlier_6',
				'outlier_7',
				'outlier_8',
				'outlier_9',
			]
			const csv = [colunas, ...medicoesParaExportar]
				.map((registro) => registro.join(';'))
				.join('\r\n')

			download(csv, 'Análise de Outliers.csv', 'text/csv')
		},

		/**
		 *  Converte data para o padrao correto do sistema: dd/MM/yyyy
		 */
		converterParaPadraoDeDataCorreto(dataFormatoOriginal) {
			if (this.dataEstaNoPadraoISO(dataFormatoOriginal)) {
				var dataFormatoCorreto = dataFormatoOriginal.split('T')[0]
				var dataSeparada = dataFormatoCorreto.split('-')
				dataFormatoCorreto = `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]}`
				return dataFormatoCorreto
			}
			return dataFormatoOriginal
		},

		/**
		 * Verifica se data esta no padrao ISO 8601
		 */
		dataEstaNoPadraoISO(data) {
			const EXPRESSAO_PARA_ISO_8601 = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/
			return EXPRESSAO_PARA_ISO_8601.test(data)
		},

		/**
		 * Cria nova medicao no banco de dados
		 */
		create() {
			this.salvando = true
			const medicao = this.createMedicaoToPost()

			createMedicao(medicao).then(async (response) => {
				const { result: medicao } = response.data
				this.disableSaveButton = false

				if (response.status === 200) {
					// this.cleanModel();
					this.formataMedicaoParaCrud(medicao)
					this.modelList.unshift(medicao)
					this.model = Object.assign(this.model, medicao)
					this.enableFileUpload = true
					this.showForm = false
					this.emptyValue = ''

					let response
					try {
						response = await importMedicaoInventarioCSV({
							idMedicao: medicao.id,
							plantios: this.medicoesPreparadas,
						})
					} catch (err) {
						const errorsData = err?.response?.data
						const mensagensDeErro = []
						if (errorsData?.errors) {
							Object.values(errorsData.errors).forEach((mensagens) => {
								if (Array.isArray(mensagens)) mensagensDeErro.push(...mensagens)
								else mensagensDeErro.push(mensagens)
							})
						} else if (Array.isArray(errorsData)) {
							mensagensDeErro.push(...errorsData)
						} else if (errorsData?.title) {
							mensagensDeErro.push(errorsData.title)
						}

						this.step = 1
						this.salvando = false
						this.disableSaveButton = false

						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: mensagensDeErro.length
								? mensagensDeErro.map((m) => `• ${m}`).join('<br>')
								: this.$t('erroAoImportarMedicao'),
							messageIcon: 'far fa-times-circle',
							messageType: 'error',
						})
						return
					}

					if (response.status === 200) {
						// this.step = 1
						this.enableFileUpload = false
						this.isEdit = true
						this.salvando = false
						this.disableSaveButton = false
						this.content = { errors: [], data: [] }
						// this.showForm = true;

						if (response.data.result.length > 0) {
							if (response.data.result[0].includes('fora da área')) {
								this.mutationShowMessage({
									messageTitle: this.$t('atencao'),
									messageText: `${this.$t('parcelasForaDaAreaDoPlantio')}:<br><br>${response.data.result.map((item) => `• ${item}`).join('<br>')}`,
									messageIcon: 'fas fa-exclamation-triangle',
									messageType: 'warning',
								})

								deleteMedicaoByIdList({
									idsMedicao: [this.model.id],
									idsOrdemDeServico: [this.model.fk_orsv_ordem_servico],
								}).then(() => {
									this.showForm = false
									this.modelList.splice(
										this.modelList.indexOf(this.modelList.find((f) => f.id === this.model.id)),
										1,
									)
								})
							}
						} else {
							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
						}
					} else {
						this.step = 1
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-cross-circle',
							messageType: 'error',
						})
					}
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Atualiza medicao no banco de dados
		 */
		update() {
			const medicao = this.createMedicaoToPut()

			updateMedicao(medicao).then((response) => {
				const { result: medicao, isError } = response.data
				this.disableSaveButton = false
				this.descriptionChanged = false
				if (!isError) {
					this.formataMedicaoParaCrud(medicao)

					const indexmedicao = this.modelList
						.map((medicaoModelList) => medicaoModelList.id)
						.indexOf(medicao.id)
					this.$set(this.modelList, indexmedicao, medicao)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui medicao no banco de dados
		 */
		deleteModels(email) {
			const emailUsuario = localStorage.getItem('email')
			if (emailUsuario === email) {
				const existeRegistroComDependencia = this.modelList.filter(
					(estratoFlorestal) =>
						this.modelsIdWithCheckedToDelete.includes(estratoFlorestal.id) &&
						estratoFlorestal.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						var medicoesToDelete = this.createMedicaoToDelete()

						deleteMedicaoByIdList(medicoesToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var medicoesOrganizadas = existeRegistroComDependencia
						.map((medicao) => `• ME-${medicao.mdco_cd_codigo} -  ${medicao.mdco_ds_descricao}`)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaCubagemProcessamentoExecutor')}:</b> <br/><br/> ${medicoesOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		async showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.initialDescription = this.model.mdco_ds_descricao
			this.step = 5
			this.titleForm = `${this.$t('edit')} ${this.$t('measurement')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
			const arvores = await recuperaDispersao(model.id)
			this.arvores = arvores.data.result

			const relation = {
				'001': 'ifi',
				'002': 'ifc',
				'003': 'ipc',
				'019': 'ifq',
			}

			this.model.tipoInventario =
				relation[
					this.tiposDeServico
						.find((ts) => ts.value === this.model.fk_tpsv_tipo_servico)
						.label.split('-')[0]
						.trim()
				]

			this.colunaAtributo = this.colunasMapeamento.map((coluna) => {
				return {
					coluna: coluna.nome,
					value: coluna.key,
					key: coluna.key,
				}
			})

			try {
				const dadosValidacaoConsistencia = await getDadosValidacaoConsistencia(model.id)
				this.dadosValidacaoConsistencia = dadosValidacaoConsistencia.data
			} catch {
				throw new Error('Não foi possivel buscar dados de validação e consistência de dados')
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.step = 1
			this.titleForm = `${this.$t('create')} ${this.$t('measurement')}`
			this.isEdit = false
			this.descriptionChanged = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.file = undefined
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>

<style>
.container__fileupload__droparea {
	margin: 1rem 0;
}
</style>
